module.exports = __webpack_public_path__ + "static/media/img-1.6115a5c4.jpg";